var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "help" } }, [
      _c("div", { staticClass: "title" }, [_vm._v("隐私条款")]),
      _c("div", { staticClass: "faq-page" }, [
        _c("p", [
          _vm._v("体验不满意，请先联系客服，如问题仍未解决，请点击投诉KJcs2"),
        ]),
        _c("p", [
          _vm._v(
            " 用户隐私权保护政策和个人信息利用政策《KJcs2用户隐私权保护政策和个人信息利用政策》 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 《隐私政策》适用于KJcs2和/或其关联公司（统称“KJcs2”或“我们”）提供的一切产品和服务（产品和服务统称为“服务”）。您在使用KJcs2的服务时，KJcs2将会收集、使用、存储、处理您的相关信息。KJcs2深知个人信息对您的重要性，将尽全力保护您的个人信息安全。KJcs2将秉承合法、正当、必要的原则，并依据本《隐私政策》的约定收集、使用、处理您的个人信息和隐私。您将通过本《隐私政策》了解以下内容： "
          ),
        ]),
        _c("p", [_vm._v("• 我们如何收集您的个人信息")]),
        _c("p", [_vm._v("• 我们如何使用您的个人信息")]),
        _c("p", [_vm._v("• 我们如何使用Cookie和同类技术")]),
        _c("p", [_vm._v("• 我们如何分享、转让、公开披露您的个人信息")]),
        _c("p", [_vm._v("• 我们如何存储和保护您的个人信息")]),
        _c("p", [_vm._v("• 您的权利")]),
        _c("p", [_vm._v("• 如何联系我们")]),
        _c("p", [
          _vm._v(
            " • 本政策如何更新KJcs2提供的单项服务可能具有专门的隐私政策或隐私条款，若该政策或条款与本《隐私政策》存在冲突的，在无相反说明的情况下，以本《隐私政策》的内容为准 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " KJcs2在提供服务的过程中可能会涉及第三方服务，包括但不限于指向方服 "
          ),
        ]),
        _c("p", [
          _vm._v("务的广告、信息或其他链接，使用KJcs2账号登录第三方服务，登录"),
        ]),
        _c("p", [
          _vm._v(
            " KJcs2服务的过程中使用第三方账号。您理解并同意，前述第三方服务并非 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 由KJcs2提供，也不受KJcs2控制，您在使用前述第三方服务时，需遵 "
          ),
        ]),
        _c("p", [_vm._v("守第三方的对应隐私政策或规则。")]),
        _c("p", [
          _vm._v(
            " 第三方进行的与您个人信息相关的任何行为均与KJcs2无关，KJcs2不 "
          ),
        ]),
        _c("p", [
          _vm._v(
            "就此承担任何责任。请您在使用KJcs2提供的服务之前仔细阅读并同意本"
          ),
        ]),
        _c("p", [
          _vm._v(
            " 《隐私政策》，当您点击“同意”、“认同”等具有认可含义的词语时，或当您开 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 始使用或继续使用KJcs2提供的服务时，即视为您已同意本《隐私政策》的 "
          ),
        ]),
        _c("p", [_vm._v("全部内容。")]),
        _c("p", [
          _vm._v(
            " 我们如何收集您的个人信息，个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " KJcs2基于本政策所述的以下目的，收集和使用您的以下个人信息。如需超过以下目的使用您的信息，KJcs2将另行征得您的同意： "
          ),
        ]),
        _c("p", [_vm._v("• 1.1您在使用我们产品或服务时主动提供的信息")]),
        _c("p", [
          _vm._v(
            " • 1.1.1为帮助您注册、登录、使用KJcs2提供的服务，您主要会向我们按需提供的相关个人信息包括您的电话号码、电子邮箱、网络账号、密码、口令、昵称、头像等信息 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 1.1.2为满足相关法律法规政策及相关主管部门的要求，KJcs2用户需要配合我们进行实名认证以继续使用和享受KJcs2。我们会在获得您同意或您主动提供的情况下收集您的实名身份信息，包括您的真实姓名、身份证号、生日、籍贯、性别、照片等，该信息属于敏感信息，若您选择不提供实名身份信息，可能会导致您无法登录KJcs2的产品或服务或在使用KJcs2的产品或服务过程中受到相应限制。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 1.1.3您通过我们的客服或参加我们举办的活动时所提交的信息。例如，您参与我们线上活动时填写的调查问卷中可能包含您的性别、文化程度、职业、年龄等信息；您参与我们的包含赠品、奖品、生日祝福等增值服务，经您同意向我们提供的相关个人信息，包括姓名、电话、家庭地址、生日等。 "
          ),
        ]),
        _c("p", [_vm._v("• 1.2我们在您使用我们产品或服务时获取的信息")]),
        _c("p", [_vm._v("• 1.2.1日志信息")]),
        _c("p", [
          _vm._v(
            " • 1.2.1.1我们会收集您的设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和终端设备（包括手机、平板电脑、电脑、移动智能设备、家用游戏机、客户设备、无线路由器、操作系统及其他必备软、硬件或上网装置）所用的型号、设备识别码、设备ID、设备名称、设备类型和版本、系统版本、MAC地址、应用ID、网络类型信息等 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 1.2.1.2我们会收集您的游戏日志信息，例如登录日志、物品日志、游戏对局信息、交友记录等，以便您能够在客户端查看您的游戏历史记录，同时用于游戏运营统计分析、客服投诉处理及其他游戏安全分析，并为提升您的游戏体验，我们可能把前述信息同步至该游戏后续版本或您正在使用的我们提供的其他产品中 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 1.2.1.3当您使用KJcs2产品的消费功能时，我们会收集您的充值记录、消费记录等信息，以便您查询您的交易记录，同时尽最大程度保护您的虚拟物品安全。充值记录、消费记录属于敏感信息，收集上述信息为实现KJcs2产品的消费功能所必须，否则将无法完成交易。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 1.2.1.4为保障您的游戏账号安全，营造公平、健康及安全的游戏环境，我们会收集您的游戏识别信息、硬件及操作系统信息、进程及游戏崩溃记录等信息，以用于打击破坏游戏公平环境或干扰、破坏游戏服务正常进行的行为（如用于检测盗版、扫描外挂、防止作弊等）。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 1.2.1.5当您使用KJcs2产品的社交功能时，您通过文字、图片、语音、视频及其他方式与其他玩家进行互动，我们可能会收集并保存您发送的上述信息内容用于过滤色情、暴力、政治、辱骂、恶意广告等不当内容，以此净化游戏环境，维护健康的上网环境。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 1.2.2位置信息：指您授权APP使用您的位置，并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括您通过具有定位功能的移动设备使用我们的服务时，通过GPS、基站、IP地址或WiFi等方式收集的您的地理位置信息；位置信息属于敏感信息，拒绝提供该信息只会导致您无法实现KJcs2服务对应的部分功能，但不影响您正常使用KJcs2服务的其他功能，您也可以随时取消您的地理位置信息授权。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 1.2.3其他相关信息：如果我们要收集本政策中未载明的您的其他个人信息，我们会通过页面提示、交互流程、网站公告或其他方式另行征得您的同意。一旦同意或继续使用我们的服务，该等额外信息将适用本政策。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 1.3第三方分享的有关您的信息• 我们可能会从第三方合作伙伴处获得或分享您在使用其提供的服务时所产生或分享的信息。您理解，根据相关法律法规的规定或服务本身的性质，若您不提供相应信息，您可能无法完成注册，或无法享受我们提供的某些服务，或无法达到相关服务预计达到的效果。 "
          ),
        ]),
        _c("p", [_vm._v("二、我们如何使用您的个人信息")]),
        _c("p", [
          _vm._v(
            " • 2.1我们会将前述收集的信息用于以下用途。若我们需要出于其他目的收集和/或使用您的个人信息的，我们会另行征求您的同意： "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 2.1.1帮助您注册KJcs2账户：为便于我们向您提供服务，您可能需要配合我们提供真实、完整、准确、有效的个人身份信息及其他相关信息以完成实名账户的注册。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 2.1.2向您提供服务：为了向您提供服务，或为了使您获得更优质的服务体验，我们将收集并使用您的必要个人信息。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 2.1.3产品开发和服务优化：在产品开发和服务优化的过程中，您的信息可能会被用于分析故障原因、分析用户需求、进行个性化定制、进行产品升级等。您在单项服务中的信息可能会被用于KJcs2提供的其他服务之中，以用于完善相关服务。 "
          ),
        ]),
        _c("p", [_vm._v("• 2.1.4向您推送信息：")]),
        _c("p", [
          _vm._v(
            " • 2.1.4.1商品或服务信息：KJcs2会根据已收集的关于您的信息，如浏览及搜索记录、设备信息、位置信息、订单信息，提取您的浏览偏好、行为习惯、位置信息等特征，通过电子邮件、短信、通知等方式向您推送相关KJcs2服务或第三方服务的广告或资讯； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 如您不希望继续接收我们推送的消息，可要求我们停止推送，例如：根据短信退订指引要求我们停止发送推广短信，或在移动设备中进行设置，不再接收我们推送的消息；但我们依法律规定或服务条款约定发送消息的情形除外。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 2.1.4.2系统公告：在必要时（如KJcs2提供的服务需要进行维护、变更、中止或终止等），我们将利用您提供的信息向您发出系统公告。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 2.1.5为您提供安全保障：为了保障您的账户安全，我们可能会将您的信息用于实名认证、身份验证、安全防范、交易风险防范、反诈骗监控、存档备份、客户服务等用途。在此过程中，我们可能会在必要的限度内向第三方提供您的信息，用以实现前述目的，并要求第三方遵守本《隐私政策》的规定。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 2.1.6其他用途：如果我们要将您的个人信息用于本政策中未载明的其他用途，我们会通过页面提示、交互流程、网站公告或其他方式另行征得您的同意。一旦同意或继续使用我们的服务，该等额外用途将视为本政策的一部分。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 2.2根据相关法律法规规定，以下情形中收集和/或使用您的信息无需征得您的授权同意： "
          ),
        ]),
        _c("p", [_vm._v("• 2.2.1与国家安全、国防安全有关的")]),
        _c("p", [_vm._v("• 2.2.2与公共安全、公共卫生、重大公共利益有关的")]),
        _c("p", [_vm._v("• 2.2.3与犯罪侦查、起诉、审判和判决执行等有关的")]),
        _c("p", [
          _vm._v(
            " • 2.2.4出于维护信息主体或其他个人的生命、财产等重大合法权益但又难以取得您本人同意的 "
          ),
        ]),
        _c("p", [_vm._v("• 2.2.5所收集的信息是您自行向社会公众公开的")]),
        _c("p", [
          _vm._v(
            " • 2.2.6从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道 "
          ),
        ]),
        _c("p", [_vm._v("• 2.2.7根据您的要求签订合同所必需的")]),
        _c("p", [
          _vm._v(
            " • 2.2.8用于维护我们服务的安全稳定运行所必需的，例如发现、处置服务的故障 "
          ),
        ]),
        _c("p", [_vm._v("• 2.2.9为合法的新闻报道所必需的")]),
        _c("p", [
          _vm._v(
            " • 2.2.10学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的 "
          ),
        ]),
        _c("p", [_vm._v("• 2.2.11法律法规规定的其他情形。")]),
        _c("p", [_vm._v("三 我们如何使用Cookie和同类技术")]),
        _c("p", [
          _vm._v(
            " • 3.1为向您提供个性化的用户体验和服务，我们或我们的第三方合作伙伴可能会通过Cookie、脚本、Web信标、FlashCookie、内嵌Web链接、本地存储器等工具自动进行信息收集，这些第三方Cookie或同类技术收集和使用该等信息不受本《隐私政策》约束，而是受到其自身的信息保护声明约束，我们不对第三方的Cookie或同类技术承担责任。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 3.2您可以通过浏览器或用户选择机制拒绝或管理Cookie及同类技术，但若您拒绝前述技术，则您可能无法享受最佳的服务体验或无法享受特定服务的部分功能。 "
          ),
        ]),
        _c("p", [_vm._v("四、我们可能分享、转让、披露您的个人信息")]),
        _c("p", [
          _vm._v(
            " • 4.1分享• 您理解并同意，经过去标识化处理后的信息将无法识别您的身份，在此情况下我们将已经去标识化的信息用于本《隐私政策》之目的，并在确保数据接收方无法重新识别个人信息主体的前提下，通过分享、转让的方式提供给第三方。我们可能在以下情况下与我们以外的任何第三方分享您的个人信息 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 4.1.1在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 4.1.2我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 4.1.3与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 4.1.4与第三方SDK类服务商共享：仅为实现本政策中声明的目的，我们的某些服务将由第三方SDK类服务商提供。我们可能会与第三方SDK类服务商共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。前述服务商收集和处理信息等行为遵守其自身的隐私条款，而不适用于本政策。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 4.2转让• 我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外： "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 4.2.1在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 4.2.2在涉及合并、收购或破产清算时，如涉及个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 4.3公开披露• 我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，披露您的个人信息 "
          ),
        ]),
        _c("p", [_vm._v("• 4.3.1获得您的明确同意或基于您的主动选择")]),
        _c("p", [
          _vm._v("• 4.3.2根据法律、法规的要求、强制性的行政执法或司法要求"),
        ]),
        _c("p", [
          _vm._v("• 4.4分享、转让、披露个人信息时事先征得授权同意的例外"),
        ]),
        _c("p", [
          _vm._v(
            " • 当发生如下情形时，我们可以不取得您的同意分享、转让、公开披露您的个人信息： "
          ),
        ]),
        _c("p", [_vm._v("• 4.4.1与国家安全、国防安全直接相关的")]),
        _c("p", [
          _vm._v("• 4.4.2与公共安全、公共卫生、重大公共利益直接相关的"),
        ]),
        _c("p", [
          _vm._v("• 4.4.3与犯罪侦查、起诉、审判和判决执行等直接相关的"),
        ]),
        _c("p", [
          _vm._v(
            " • 4.4.4出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的 "
          ),
        ]),
        _c("p", [_vm._v("• 4.4.5个人信息主体自行向社会公众公开的个人信息")]),
        _c("p", [
          _vm._v(
            " • 4.4.6从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道 "
          ),
        ]),
        _c("p", [_vm._v("• 4.4.7法律法规规定的其他情形。")]),
        _c("p", [_vm._v("五、我们如何存储和保护您的个人信息• 5.1信息存储：")]),
        _c("p", [
          _vm._v(
            " • 5.1.1存储地点：我们将根据相关法律法规的要求存储您的个人信息，在法律适用的情况下，对于我们在中华人民共和国境内收集的信息，我们将存储在中国境内。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 5.1.2存储期限：我们将按相关法律法规的要求，依据本《隐私政策》第二条目的得以实现的必要期限，来存储您的信息。 "
          ),
        ]),
        _c("p", [_vm._v("• 5.2信息保护：")]),
        _c("p", [
          _vm._v(
            " • 5.2.1我们将采取符合法律要求及业界标准的、合理可行的安全防护措施保护您的个人信息，防止数据遭到未经授权的访问、披露、使用、修改、损坏或丢失。依据实际情况，我们可能采取的安全防护措施包括使用加密技术（例如SSL、TLS）处理个人信息、对个人信息进行匿名化处理或脱敏处理、为相关网站提供https安全浏览方式、建立数据分类分级、安全管理、内部访问权限等制度、开展内部安全和隐私保护培训等。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 5.2.2若发生个人信息安全事件，我们将按照法律法规的要求，启动相应的应急预案，并及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，及时上报个人信息安全事件的处置情况六、您的权利按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利： "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 6.1访问您的个人信息• 您有权在使用我们服务的过程中访问您的个人信息，我们在单项服务中为您提供了相应的操作设置，您可据此进行操作。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 6.2分享您的个人信息• 您可以通过我们的服务与第三人分享您的个人信息。请注意，只要您不删除已公开发布的信息，相关信息将一直留存在公开领域；即便您已删除分享信息，相关信息也可能被第三人缓存、收集、复制或向公众提供。请您谨慎考虑披露您的个人信息，特别是个人敏感信息（如您的种族、宗教、个人健康和医疗信息、身份证明文件、个人生物识别信息、财产信息、行踪轨迹、未成年人的信息），您可以使用我们的相关设置（如有）来控制您分享信息的范围。如您通过上述渠道公开您的个人信息，由此导致的您的信息的泄漏，或对您或他人的损害，我们不承担任何责任。 "
          ),
        ]),
        _c("p", [_vm._v("• 6.3要求更正或删除您的个人信息")]),
        _c("p", [
          _vm._v(
            " • 若您发现我们处理的关于您的个人信息存在错误的，可以要求我们进行更正。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 若您发现我们处理您个人信息的行为违反法律法规、与您的约定、本《隐私政策》，或您不再使用我们的服务的或已注销了账号，您可以要求我们删除您的个人信息。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 您理解，依据相关法律法规的强制性规定，我们可能无法响应您要求删除信息的特定要求。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 您理解，您的部分或全部个人信息被删除后，与此相关的我们的服务，或其对应部分可能无法使用。 "
          ),
        ]),
        _c("p", [_vm._v("• 6.4改变您授权同意的范围")]),
        _c("p", [
          _vm._v(
            " • 您可以通过我们公布的渠道和方式改变您授权我们收集、使用、存储的个人信息的范围。当您撤回授权后，我们将无法继续为您提供撤回授权所对应的服务，也不再处理您的相应信息。 "
          ),
        ]),
        _c("p", [_vm._v("• 6.5响应您的上述请求")]),
        _c("p", [
          _vm._v(
            " • 6.5.1为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在合理时限内做出答复。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 6.5.2对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 6.5.3在以下情形中，按照法律法规要求，我们将无法响应您的请求： "
          ),
        ]),
        _c("p", [_vm._v("• 6.5.3.1与国家安全、国防安全直接相关的；")]),
        _c("p", [
          _vm._v("• 6.5.3.2与公共安全、公共卫生、重大公共利益直接相关的；"),
        ]),
        _c("p", [
          _vm._v("• 6.5.3.3与犯罪侦查、起诉、审判和判决执行等直接相关的；"),
        ]),
        _c("p", [
          _vm._v("• 6.5.3.4有充分证据表明您存在主观恶意或滥用权利的；"),
        ]),
        _c("p", [
          _vm._v(
            " • 6.5.3.5响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的； "
          ),
        ]),
        _c("p", [_vm._v("• 6.5.3.6涉及商业秘密的；")]),
        _c("p", [_vm._v("• 6.5.3.7其他我们有合理理由拒绝的情形。")]),
        _c("p", [
          _vm._v(
            " 七、如何联系我们如果您对本《隐私政策》、您的个人信息收集、使用、存储等存在问题，或有任何问题、建议或意见，请即刻聯繫客服。我们将尽快审核所涉问题，并在验证身份后及时处理。 "
          ),
        ]),
        _c("p", [_vm._v("八、本政策如何更新")]),
        _c("p", [
          _vm._v(
            " • 8.1我们可能会对本《隐私政策》进行不定期的更新，并通过公告等方式进行公示。若存在对您权利产生实质性减损的变更，我们将通过在页面显著位置提示、向您发送电子邮件等合理方式向您告知。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " • 8.2若您继续使用我们的服务，则视为您同意接受更新后的《隐私政策》。我们的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。详情内容请访问《DCloud用户服务条款》。（DCloud用户服务条款超链至：https://ask.dcloud.net.cn/protocol.html）九、网络安全事件应急预案     "
          ),
        ]),
        _c("p", [_vm._v("十、总则 ")]),
        _c("p", [
          _vm._v(
            " 10.1.1 编制目的 建立健全国家网络安全事件应急工作机制，提高应对网络安全事件能力，预防和减少网络安全事件造成的损失和危害，保护公众利益，维护国家安全、公共安全和社会秩序。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 10.1.2 编制依据 《中华人民共和国突发事件应对法》、《中华人民共和国网络安全法》、《国家突发公共事件总体应急预案》、《突发事件应急预案管理办法》和《信息安全技术信息安全事件分类分级指南》（GB/Z 20986-2007）等相关规定。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 10.1.3 适用范围 本预案所指网络安全事件是指由于人为原因、软硬件缺陷或故障、自然灾害等，对网络和信息系统或者其中的数据造成危害，对社会造成负面影响的事件，可分为有害程序事件、网络攻击事件、信息破坏事件、信息内容安全事件、设备设施故障、灾害性事件和其他事件。本预案适用于网络安全事件的应对工作。其中，有关信息内容安全事件的应对，另行制定专项预案。 10.1.4 事件分级 网络安全事件分为四级：特别重大网络安全事件、重大网络安全事件、较大网络安全事件、一般网络安全事件。  "
          ),
        ]),
        _c("p", [_vm._v("（1）符合下列情形之一的，为特别重大网络安全事件： ")]),
        _c("p", [
          _vm._v(
            " ①重要网络和信息系统遭受特别严重的系统损失，造成系统大面积瘫痪，丧失业务处理能力。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " ②国家秘密信息、重要敏感信息和关键数据丢失或被窃取、篡改、假冒，对国家安全和社会稳定构成特别严重威胁。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            "  ③其他对国家安全、社会秩序、经济建设和公众利益构成特别严重威胁、造成特别严重影响的网络安全事件。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " （2）符合下列情形之一且未达到特别重大网络安全事件的，为重大网络安全事件：  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " ①重要网络和信息系统遭受严重的系统损失，造成系统长时间中断或局部瘫痪，业务处理能力受到极大影响。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " ②国家秘密信息、重要敏感信息和关键数据丢失或被窃取、篡改、假冒，对国家安全和社会稳定构成严重威胁。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " ③其他对国家安全、社会秩序、经济建设和公众利益构成严重威胁、造成严重影响的网络安全事件。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " （3）符合下列情形之一且未达到重大网络安全事件的，为较大网络安全事件： ①重要网络和信息系统遭受较大的系统损失，造成系统中断，明显影响系统效率，业务处理能力受到影响。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " ②国家秘密信息、重要敏感信息和关键数据丢失或被窃取、篡改、假冒，对国家安全和社会稳定构成较严重威胁。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " ③其他对国家安全、社会秩序、经济建设和公众利益构成较严重威胁、造成较严重影响的网络安全事件。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " （4）除上述情形外，对国家安全、社会秩序、经济建设和公众利益构成一定威胁、造成一定影响的网络安全事件，为一般网络安全事件。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 10.1.5 工作原则 坚持统一领导、分级负责；坚持统一指挥、密切协同、快速反应、科学处置；坚持预防为主，预防与应急相结合；坚持谁主管谁负责、谁运行谁负责，充分发挥各方面力量共同做好网络安全事件的预防和处置工作。 "
          ),
        ]),
        _c("p", [_vm._v("十一、组织机构与职责 ")]),
        _c("p", [
          _vm._v(
            " 11.1.1 领导机构与职责 在中央网络安全和信息化领导小组（以下简称“领导小组”）的领导下，中央网络安全和信息化领导小组办公室（以下简称“中央网信办”）统筹协调组织国家网络安全事件应对工作，建立健全跨部门联动处置机制，工业和信息化部、公安部、国家保密局等相关部门按照职责分工负责相关网络安全事件应对工作。必要时成立国家网络安全事件应急指挥部（以下简称“指挥部”），负责特别重大网络安全事件处置的组织指挥和协调。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 11.1.2 办事机构与职责 国家网络安全应急办公室（以下简称“应急办”）设在中央网信办，具体工作由中央网信办网络安全协调局承担。应急办负责网络安全应急跨部门、跨地区协调工作和指挥部的事务性工作，组织指导国家网络安全应急技术支撑队伍做好应急处置的技术支撑工作。有关部门派负责相关工作的司局级同志为联络员，联络应急办工作。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 11.1.3 各部门职责 中央和国家机关各部门按照职责和权限，负责本部门、本行业网络和信息系统网络安全事件的预防、监测、报告和应急处置工作。 "
          ),
        ]),
        _c("p", [_vm._v("十二、监测与预警 ")]),
        _c("p", [
          _vm._v(
            " 12.1.1 预警分级 ，网络安全事件预警等级分为四级：由高到低依次分别对应发生或可能发生特别重大、重大、较大和一般网络安全事件。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 12.1.2 预警监测按照“谁主管谁负责、谁运行谁负责”的要求，组织对本单位建设运行的网络和信息系统开展网络安全监测工作。主管部门组织指导做好网络安全监测工作。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 12.1.3 预警研判和发布 各部门组织对监测信息进行研判，认为需要立即采取防范措施的，应当及时通知有关部门，对可能发生重大及以上网络安全事件的信息及时向应急办报告。各部门可根据监测研判情况，发布预警。 预警信息包括事件的类别、预警级别、起始时间、可能影响范围、警示事项、应采取的措施和时限要求、发布机关等。 "
          ),
        ]),
        _c("p", [_vm._v("12.1.4 预警响应 ")]),
        _c("p", [_vm._v("12.1.4.1 特别重大网络安全预警响应 ")]),
        _c("p", [
          _vm._v(
            " （1）主管部门组织预警响应工作，联系专家和有关机构，组织对事态发展情况进行跟踪研判，研究制定防范措施和应急工作方案，协调组织资源调度和部门联动的各项准备工作。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " （2）网络安全事件应急指挥部门实行24小时值班，相关人员保持通信联络畅通。加强网络安全事件监测和事态发展信息搜集工作，组织指导应急支撑队伍、相关运行部门开展应急处置或准备、风险评估和控制工作，重要情况报主管部门。 "
          ),
        ]),
        _c("p", [_vm._v("12.1.4.2 重大网络安全预警响应 ")]),
        _c("p", [
          _vm._v(
            " （1）网络安全事件应急指挥部门启动相应应急预案，组织开展预警响应工作，做好风险评估、应急准备和风险控制工作。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " （2）有关部门及时将事态发展情况报主管部门。主管部门密切关注事态发展，有关重大事项及时通报相关部门。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " （3）网络安全应急技术支撑队伍保持联络畅通，检查应急设备、软件工具等，确保处于良好状态。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 12.1.4.3 较大、一般网络安全预警响应 网络安全事件应急指挥部门启动相应应急预案，指导组织开展预警响应。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 12.1.4.4 预警解除 预警发布部门或地区根据实际情况，确定是否解除预警，及时发布预警解除信息。 "
          ),
        ]),
        _c("p", [_vm._v("十三、应急处置 ")]),
        _c("p", [
          _vm._v(
            " 13.1.1 事件报告 网络安全事件发生后，事发部门应立即启动应急预案，实施处置并及时报送信息。各有关部门立即组织先期处置，控制事态，消除隐患，同时组织研判，注意保存证据，做好信息通报工作。对于初判为特别重大、重大网络安全事件的，立即报告主管部门。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 13.1.2 应急响应 网络安全事件应急响应分为四级，分别对应特别重大、重大、较大和一般网络安全事件。I级为最高响应级别。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 13.1.2.1 Ⅰ级响应 属特别重大网络安全事件的，及时启动I级响应，成立指挥部，履行应急处置工作的统一领导、指挥、协调职责。应急办24小时值班。 应急指挥部门进入应急状态，在指挥部的统一领导、指挥、协调下，负责应急处置工作或支援保障工作，24小时值班，并派员参加应急办工作。 有关部门跟踪事态发展，检查影响范围，及时将事态发展变化情况、处置进展情况报主管部门。指挥部对应对工作进行决策部署，有关部门负责组织实施。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 13.1.2.2 Ⅱ级响应 网络安全事件的Ⅱ级响应，由有关部门根据事件的性质和情况确定。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " （1）事件发生部门的应急指挥机构进入应急状态，按照相关应急预案做好应急处置工作。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " （2）事件发生部门及时将事态发展变化情况报应急办。主管部门将有关重大事项及时通报相关部门。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            "  （3）处置中需要其他有关部门和国家网络安全应急技术支撑队伍配合和支持的，商应急办予以协调。相关部门和国家网络安全应急技术支撑队伍应根据各自职责，积极配合、提供支持。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " （4）有关部门根据应急办的通报，结合各自实际有针对性地加强防范，防止造成更大范围影响和损失。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 13.1.2.3 Ⅲ级、Ⅳ级响应 事件发生部门按相关预案进行应急响应。  "
          ),
        ]),
        _c("p", [_vm._v("13.1.3 应急结束 ")]),
        _c("p", [
          _vm._v(
            " 13.1.3.1 Ⅰ级响应结束 主管部门提出建议，报指挥部批准后，及时通报有关部门。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 13.1.3.2 Ⅱ级响应结束 由事件发生部门决定，报主管部门，主管部门通报相关部门。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 十四、调查与评估 特别重大网络安全事件由主管部门组织有关部门进行调查处理和总结评估，并按程序上报。重大及以下网络安全事件由事件发生部门自行组织调查处理和总结评估，其中重大网络安全事件相关总结调查报告报主管部门。总结调查报告应对事件的起因、性质、影响、责任等进行分析评估，提出处理意见和改进措施。 事件的调查处理和总结评估工作原则上在应急响应结束后30天内完成。 "
          ),
        ]),
        _c("p", [_vm._v("十五、预防工作 ")]),
        _c("p", [
          _vm._v(
            " 15.1.1 日常管理 各部门按职责做好网络安全事件日常预防工作，制定完善相关应急预案，做好网络安全检查、隐患排查、风险评估和容灾备份，健全网络安全信息通报机制，及时采取有效措施，减少和避免网络安全事件的发生及危害，提高应对网络安全事件的能力。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 15.1.2 演练 有关部门定期组织演练，检验和完善预案，提高实战能力。 各部门每年至少组织一次预案演练，并将演练情况报主管部门。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 15.1.3培训 各部门要将网络安全事件的应急知识列为领导干部和有关人员的培训内容，加强网络安全特别是网络安全应急预案的培训，提高防范意识及技能。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            "  15.1.4重要活动期间的预防措施，在重要活动期间，各部门要加强网络安全事件的防范和应急响应，确保网络安全。主管部门统筹协调网络安全保障工作，根据需要要求有关部门启动红色预警响应。有关部门加强网络安全监测和分析研判，及时预警可能造成重大影响的风险和隐患，重点部门、重点岗位保持24小时值班，及时发现和处置网络安全事件隐患。 "
          ),
        ]),
        _c("p", [_vm._v("十六、保障措施")]),
        _c("p", [
          _vm._v(
            "   16.1.1 机构和人员 各部门要落实网络安全应急工作责任制，把责任落实到具体岗位和个人，并建立健全应急工作机制。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 16.1.2 技术支撑队伍 加强网络安全应急技术支撑队伍建设，做好网络安全事件的监测预警、预防防护、应急处置、应急技术支援工作。支持网络安全企业提升应急处置能力，提供应急技术支援。各部门应配备必要的网络安全专业技术人才，并加强与国家网络安全相关技术单位的沟通、协调，建立必要的网络安全信息共享机制。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 16.1.3 专家队伍 建立国家网络安全应急专家组，为网络安全事件的预防和处置提供技术咨询和决策建议。各部门加强各自的专家队伍建设，充分发挥专家在应急处置工作中的作用。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 16.1.4 社会资源 从教育科研机构、企事业单位、协会中选拔网络安全人才，汇集技术与数据资源，建立网络安全事件应急服务体系，提高应对特别重大、重大网络安全事件的能力。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 16.1.5 基础平台各部门加强网络安全应急基础平台和管理平台建设，做到早发现、早预警、早响应，提高应急处置能力。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 16.1.6 技术研发和产业促进 有关部门加强网络安全防范技术研究，不断改进技术装备，为应急响应工作提供技术支撑。加强政策引导，重点支持网络安全监测预警、预防防护、处置救援、应急服务等方向，提升网络安全应急产业整体水平与核心竞争力，增强防范和处置网络安全事件的产业支撑能力。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 16.1.7 国际合作有关部门建立国际合作渠道，签订合作协定，必要时通过国际合作共同应对突发网络安全事件。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 16.1.8 物资保障 加强对网络安全应急装备、工具的储备，及时调整、升级软件硬件工具，不断增强应急技术支撑能力。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 16.1.9 经费保障 财务部门为网络安全事件应急处置提供必要的资金保障。有关部门利用现有政策和资金渠道，支持网络安全应急技术支撑队伍建设、专家队伍建设、基础平台建设、技术研发、预案演练、物资保障等工作开展。各部门为网络安全应急工作提供必要的经费保障。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 16.1.10 责任与奖惩 网络安全事件应急处置工作实行责任追究制。 有关部门对网络安全事件应急管理工作中作出突出贡献的先进集体和个人给予表彰和奖励。 有关部门对不按照规定制定预案和组织开展演练，迟报、谎报、瞒报和漏报网络安全事件重要情况或者应急管理工作中有其他失职、渎职行为的，依照相关规定对有关责任人给予处分；构成犯罪的，依法追究刑事责任。  "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 本预案自印发之日起实施。本《隐私协议》版权由KJcs2所有，KJcs2保留一切对本《隐私协议》解释的权利。 "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }